<template>
    <div class="layout">
        <div class="cabinet-page_bg"></div>

        <div class="content">

            <div class="content-right">
                <div class="content-right-inner">
                    <div class="logo">
                        <Logo/>
                    </div>
                    <div class="title">Восстановление пароля</div>
                    <div class="form">

                        <fieldset class="form-field-input filled"
                                  v-bind:class="{'error-field' : errors.has('password')}"
                        >
                            <label>
                                <input
                                        v-model="password"
                                        name="password"
                                        type="password"
                                        class="dev-password"
                                        @keyup.enter="refreshPassword"
                                        autocomplete="off"
                                        ref="password"
                                        v-validate="{required: true, regex: /^[\dA-Za-z]{4,16}$/}"
                                >
                                <div class="label-text">Новый пароль</div>
                                <div v-show="errors.has('password')" class="msg-form msg-error-field">{{
                                    errors.first('password') }}
                                </div>
                            </label>
                        </fieldset>

                        <fieldset class="form-field-input filled"
                                  v-bind:class="{'error-field' : errors.has('passwordRepeatRecovery')}"
                        >
                            <label>
                                <input v-model="passwordRepeatRecovery"
                                       name="passwordRepeatRecovery"
                                       type="password"
                                       class="dev-password"
                                       autocomplete="off"
                                       @keyup.enter="refreshPassword"
                                       v-validate="'required|confirmed:password'">
                                <div class="label-text">Подтвердите новый пароль</div>
                                <div v-show="errors.has('passwordRepeatRecovery')" class="msg-form msg-error-field">
                                    {{errors.first('passwordRepeatRecovery') }}
                                </div>
                            </label>
                        </fieldset>

                        <div class="button-block">
                            <button class="button button-dark"
                                    :disabled="isBlocked || pressed"
                                    type="button"
                                    @click="this.refreshPassword"
                            >Сохранить
                            </button>
                        </div>

                    </div>

                </div>
            </div>

            <router-link :to="{name: 'Index'}" class="btn-back">
                <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 14H28M2 14L15.4729 27M2 14L15.4729 1" stroke="black" stroke-width="2"/>
                </svg>
                <span>На главную</span>
            </router-link>

        </div>

        <div class="forgot-page-bg"></div>

    </div>
</template>



<script>
    import Logo from "../components/icons/Logo";
    import {Validator} from 'vee-validate';
    import constants from '@/constants';

    export default {
        components: {Logo},

        name: 'PasswordRecovery',

        metaInfo: {
            title: 'Password Recovery'
        },


        data() {
            return {
                id: this.$route.query.i,
                password: '',
                passwordRepeatRecovery: '',
                pressed: false,
                recoveryToken: this.$route.params.token
            }
        },

        beforeCreate() {
            $('body').attr('class', 'forgot-page index-layout');
        },

        mounted() {

            $('.dev-password').bind('paste', function (e) {
                e.preventDefault();
                return false;
            });

            Validator.localize('en', constants.dictionary);
            this.$refs.password.focus();
        },

        computed: {
            isBlocked() {
                return !(Object.keys(this.fields).every(key => this.fields[key].valid))
            }
        },

        methods: {
            async refreshPassword() {
                this.pressed = true;
                if (!!this.isBlocked) {
                    this.pressed = false;
                    return;
                }
                try {
                    let data = {
                        newPassword: this.password,
                        id: this.id,
                        recoveryToken: this.recoveryToken
                    };
                    await this.$store.dispatch('setNewPassword', data);
                    this.$router.push({name: 'Index', query: {login: 'true'}});
                } catch (e) {
                    this.pressed = false;
                    alert("Непредвиденная ошибка на сервере!")
                }
            },

            redirect() {
                $('.window-wrapper .btn-close').click();
                let redirectTo = sessionStorage.getItem(constants.SESSION_STORAGE_REDIRECT);
                if (redirectTo && redirectTo.length > 0) {
                    sessionStorage.removeItem(constants.SESSION_STORAGE_REDIRECT);
                    this.$router.push(redirectTo);
                } else {
                    let userRole = this.$store.getters.currentUser.role;
                    if (['ROLE_ADMIN'].includes(userRole)) {
                        this.$router.push({name: 'Clients'});
                    } else {
                        this.$router.push({name: 'ClientMails'});
                    }
                }
            }
        }
    }
</script>